import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMarathonsDistancesPriceParams,
  GetMarathonsDistancesPriceResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMarathonsDistancesPrice = createAsyncThunk<
  GetMarathonsDistancesPriceResponse,
  GetMarathonsDistancesPriceParams
>(
  "marathons/getMarathonsDistancesPrice",
  async ({ marathonId, distanceId, ...params }, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMarathonsDistancesPrice({
        marathonId,
        distanceId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting marathons distances price", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting marathons distances price", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
